import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import set from 'lodash/set'
import get from 'lodash/get'
import moment from '../../lib/moment.js'
import { Container, TabContent, TabPane } from 'reactstrap'
import {
  authAction,
  efficiencyAction,
} from './../../actions/'
import {
  authSelector,
  efficiencySelector,
} from './../../selectors'
import withLayout from '../../helpers/withLayout'
import {
  Tab,
  Overall,
  LOBOverview,
  LOBSubmit,
} from '../../components/efficiency-resource'
import Manual from '../../components/efficiency-resource/manual'

class EfficiencyResourcePage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const access_token = localStorage.getItem('access_token')
    const tempState = prevState
    if (get(nextProps, 'getEfficiencyData.efficiencyResources')) {
      const efficiencyResources = get(nextProps, 'getEfficiencyData.efficiencyResources')
      set(tempState, 'efficiencyResources', get(efficiencyResources, 'efficiencyResources'))
      set(tempState, 'lobs', get(efficiencyResources, 'lobs'))
      set(tempState, 'lob_ids', get(efficiencyResources, 'lob_ids'))
      set(tempState, 'users', get(efficiencyResources, 'users'))
      set(tempState, 'chargeableSummary', get(efficiencyResources, 'chargeableSummary'))
      set(tempState, 'overallSummary', get(efficiencyResources, 'overallSummary'))
    }
    if (get(nextProps, 'getEfficiencyLOBData.efficiencyResource')) {
      set(tempState, 'efficiencyResource', get(nextProps, 'getEfficiencyLOBData.efficiencyResource'))
      nextProps.resetGetEfficiencyLOB()
    }
    if (get(nextProps, 'submitEfficiencyData.submittedEfficiencyResource')) {
      const submitted = get(nextProps, 'submitEfficiencyData.submittedEfficiencyResource')
      if (get(nextProps, 'submitEfficiencyData.status') === 200) {
        nextProps.getEfficiencyLOB(get(submitted, 'lob_id'), moment(get(submitted, 'month')).format('YYYY-MM'), access_token)
      }
      nextProps.resetSubmitEfficiency()
    }
    if (get(nextProps, 'editEfficiencyData.updatedEfficiencyResource')) {
      const updatedEfficiencyResource = get(nextProps, 'editEfficiencyData.updatedEfficiencyResource')
      const lobID = get(updatedEfficiencyResource, 'lob_id')
      const month = moment(get(updatedEfficiencyResource, 'month')).format('YYYY-MM')
      if (get(nextProps, 'editEfficiencyData.status') === 200) {
        nextProps.getEfficiencyLOB(lobID, month, access_token)
      }
      nextProps.resetEditEfficiency()
    }
    if (get(nextProps, 'exportEfficiencyData')) {
      window.open(get(nextProps, 'exportEfficiencyData'))
      nextProps.resetExportEfficiencyLOB()
    }
    const IsManagementUser = get(nextProps, 'authData.user.is_management_role')
    const IsLOBLeadUser = get(nextProps, 'authData.user.is_lob_lead_role')
    const IsSubmitEfficiencyUser = get(nextProps, 'authData.user.is_submit_efficiency_role')
    const IsAdminUser = get(nextProps, 'authData.user.is_hr_admin_role')
    const IsHRConfidentialUser = get(nextProps, 'authData.user.is_hr_admin_confidential_role')
    const lobID = get(nextProps, 'authData.user.lob_id')
    if ((!(IsManagementUser || IsAdminUser || IsHRConfidentialUser)
      && (IsLOBLeadUser || IsSubmitEfficiencyUser)) && prevState.activeTab === 1) {
      if (lobID) {
        const month = moment().subtract(1, 'month')
        nextProps.getEfficiencyLOB(localStorage.getItem('lob_id'), month.format('YYYY-MM'), access_token)
        set(tempState, 'activeTab', 3)
      } else {
        const month = moment().subtract(1, 'month')
        nextProps.getEfficiency(month.startOf('month'), month.endOf('month'), access_token)
        set(tempState, 'activeTab', 2)
      }
    }
    return tempState
  }

  state = {
    activeTab: 1,
    submitTab: 1,
    period: moment().subtract(1, 'month'),
    startDateOverview: moment().subtract(1, 'month').startOf('month'),
    endDateOverview: moment().subtract(1, 'month').endOf('month'),
    lobOverview: '',
    selectedIDs: [],
    setDefault: true
  }

  componentDidMount() {
    if (get(this.props, 'location.pathname') === `/efficiency_resource/lob/${get(this.props, 'match.params.id')}`) {
      get(this.props, 'history').replace('/efficiency_resource', { header: 'Efficiency Resource' })
    }
    const access_token = localStorage.getItem('access_token')
    const month = moment().subtract(1, 'month')
    this.props.getAuth(access_token)
    this.props.getEfficiency(month.startOf('month'), month.endOf('month'), access_token, true)
  }

  toggleTab = (tab) => {
    if (get(this.props, 'location.pathname') === `/efficiency_resource/lob/${get(this.props, 'match.params.id')}`) {
      get(this.props, 'history').replace('/efficiency_resource', { header: 'Efficiency Resource' })
    }
    this.setState({ activeTab: tab })
    const access_token = localStorage.getItem('access_token')
    const month = moment().subtract(1, 'month')
    if (tab === 1) {
      let ids = ''
      this.state.selectedIDs.forEach(lob => { ids += `${get(lob, 'value')},` })
      this.setState({ period: month })
      this.props.getEfficiency(month.startOf('month'), month.endOf('month'), access_token, true, ids)
    } else if (tab === 2) {
      const { startDateOverview, endDateOverview } = this.state
      this.props.getEfficiency(startDateOverview, endDateOverview, access_token)
    } else if (tab === 3) {
      const lobID = localStorage.getItem('lob_id')
      this.props.getEfficiencyLOB(lobID, month.format('YYYY-MM'), access_token)
    }
  }

  toggleTabSubmit = (tab) => {
    this.setState({ submitTab: tab })
  }

  handleSelectLOB = (lobs) => {
    if (this.state.setDefault) this.setState({ setDefault: false })
    let ids = ''
    lobs.forEach(lob => { ids += `${get(lob, 'value')},` })
    this.setState({ selectedIDs: lobs })
    const access_token = localStorage.getItem('access_token')
    const period = moment(this.state.period)
    this.props.getEfficiency(period.startOf('month'), period.endOf('month'), access_token, true, ids)
  }

  handlePeriod = (period) => {
    this.setState({ period })
    const access_token = localStorage.getItem('access_token')
    let ids = ''
    const { selectedIDs } = this.state
    selectedIDs.forEach(lob => { ids += `${get(lob, 'value')},` })
    this.props.getEfficiency(moment(period).startOf('month'), moment(period).endOf('month'), access_token, true, ids)
  }

  handleInputOverview = (type, e) => {
    const access_token = localStorage.getItem('access_token')
    switch (type) {
      case 'lob': {
        this.setState({ lobOverview: e.target.value })
        break
      }
      case 'start_date': {
        this.setState({ startDateOverview: e })
        this.props.getEfficiency(moment(e).startOf('month'), moment(this.state.endDateOverview).endOf('month'), access_token)
        break
      }
      case 'end_date': {
        this.setState({ endDateOverview: e })
        this.props.getEfficiency(moment(this.state.startDateOverview).startOf('month'), moment(e).endOf('month'), access_token)
        break
      }
      default: break
    }
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
      || get(this.props, 'redirectEfficiency.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectEfficiency.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      return <Redirect to='/home' />
    }
    const isFetching = get(this.props, 'getIsFetching')
    const isOpenManual = get(this.props, 'isOpenManual')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsAccountantUser = get(this.props, 'authData.user.is_accountant_role')
    const IsSubmitEfficiencyUser = get(this.props, 'authData.user.is_submit_efficiency_role')
    const lobID = get(this.props, 'authData.user.lob_id')
    const canSeeOverall =
      IsSystemUser || IsManagementUser || IsAdminUser || IsHRConfidentialUser || IsAccountantUser
    const canSeeSubmit = (IsManagementUser || IsLOBLeadUser || IsSubmitEfficiencyUser) && (lobID && lobID !== '')

    if (IsSystemUser && IsManagementUser && IsLOBLeadUser
      && IsAdminUser && IsHRConfidentialUser && IsAccountantUser && IsSubmitEfficiencyUser
      && !(IsSystemUser || IsManagementUser || IsLOBLeadUser || IsAdminUser || IsHRConfidentialUser || IsAccountantUser || IsSubmitEfficiencyUser)) window.location = '/home'

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        { isOpenManual &&
        <Manual
          isOpen={ isOpenManual }
          closeManual={ this.props.closeManual }
        />
        }
        <Tab
          canSeeOverall={ canSeeOverall }
          canSeeSubmit={ canSeeSubmit }
          toggleTab={ this.toggleTab }
          activeTab={ this.state.activeTab }
          period={ this.state.period }
          lobs={ this.state.lobs }
          lob_ids={ this.state.lob_ids }
          setDefault={ this.state.setDefault }
          selectedIDs={ this.state.selectedIDs }
          efficiencyResources={ this.state.efficiencyResources }
          startDateOverview={ this.state.startDateOverview }
          endDateOverview={ this.state.endDateOverview }
          lobOverview={ this.state.lobOverview }
          handlePeriod={ this.handlePeriod }
          handleSelectLOB={ this.handleSelectLOB }
          handleInputOverview={ this.handleInputOverview }
          location={ get(this.props, 'location.pathname') }
          path={ get(this.props, 'match.params.id') }
        />
        { !isFetching &&
        <TabContent activeTab={ this.state.activeTab } >
          { this.state.activeTab === 1 &&
          <TabPane tabId={ 1 }>
            <Overall
              efficiencyResources={ this.state.efficiencyResources }
              lobs={ this.state.lobs }
              lob_ids={ this.state.lob_ids }
              setDefault={ this.state.setDefault }
              period={ this.state.period }
              selectedIDs={ this.state.selectedIDs }
              overallSummary={ this.state.overallSummary }
              chargeableSummary={ this.state.chargeableSummary }
            />
          </TabPane>
          }
          { this.state.activeTab === 2 &&
          <TabPane tabId={ 2 }>
            <LOBOverview
              efficiencyResources={ this.state.efficiencyResources }
              efficiencyResource={ this.state.efficiencyResource }
              lobOverview={ this.state.lobOverview }
              users={ this.state.users }
              lobs={ this.state.lobs }
              location={ get(this.props, 'location.pathname') }
              path={ get(this.props, 'match.params.id') }
              history={ get(this.props, 'history') }
              getEfficiencyLOB={ (lobId, month) => this.props.getEfficiencyLOB(lobId, month, localStorage.getItem('access_token')) }
              exportEfficiencyLOB={ (lobId, month) => this.props.exportEfficiencyLOB(lobId, month, localStorage.getItem('access_token')) }
            />
          </TabPane>
          }
          { this.state.activeTab === 3 &&
          <TabPane tabId={ 3 }>
            <LOBSubmit
              submitTab={ this.state.submitTab }
              efficiencyResource={ this.state.efficiencyResource }
              isLoaded={ this.state.isLoaded }
              getEfficiencyLOB={ (lobId, month) => this.props.getEfficiencyLOB(lobId, month, localStorage.getItem('access_token')) }
              exportEfficiencyLOB={ (lobId, month) => this.props.exportEfficiencyLOB(lobId, month, localStorage.getItem('access_token')) }
              submitEfficiency={ (id, payload) => this.props.submitEfficiency(id, payload, localStorage.getItem('access_token')) }
              editEfficiency={ (id, payload) => this.props.editEfficiency(id, payload, localStorage.getItem('access_token')) }
              toggleTabSubmit={ this.toggleTabSubmit }
            />
          </TabPane>
          }
        </TabContent>
        }
      </Wrapper>
    )
  }
}

EfficiencyResourcePage.propTypes = {
  getAuth: PropTypes.func.isRequired,
  getEfficiency: PropTypes.func.isRequired,
  getEfficiencyLOB: PropTypes.func.isRequired,
  exportEfficiencyLOB: PropTypes.func.isRequired,
  submitEfficiency: PropTypes.func.isRequired,
  editEfficiency: PropTypes.func.isRequired,
  closeManual: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectEfficiency: efficiencySelector.redirectEfficiency,
  getIsFetching: efficiencySelector.getIsFetching,
  getEfficiencyData: efficiencySelector.getEfficiencyData,
  getEfficiencyLOBData: efficiencySelector.getEfficiencyLOBData,
  exportEfficiencyData: efficiencySelector.exportEfficiencyData,
  submitEfficiencyData: efficiencySelector.submitEfficiencyData,
  editEfficiencyData: efficiencySelector.editEfficiencyData,
  isOpenManual: efficiencySelector.isOpenManual,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuth,
  closeManual: efficiencyAction.closeManual,
  getEfficiency: efficiencyAction.getEfficiency,
  getEfficiencyLOB: efficiencyAction.getEfficiencyLOB,
  resetGetEfficiencyLOB: efficiencyAction.resetGetEfficiencyLOB,
  exportEfficiencyLOB: efficiencyAction.exportEfficiencyLOB,
  resetExportEfficiencyLOB: efficiencyAction.resetExportEfficiencyLOB,
  submitEfficiency: efficiencyAction.submitEfficiency,
  resetSubmitEfficiency: efficiencyAction.resetSubmitEfficiency,
  editEfficiency: efficiencyAction.editEfficiency,
  resetEditEfficiency: efficiencyAction.resetEditEfficiency,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(EfficiencyResourcePage))

const Wrapper = styled(Container)`
  @media (max-width: 575.98px) {
    padding-right:0%;
  }
  @media (max-width: 767.98px) {
    padding-right:0%;
  }
  @media (max-width: 991.98px) {
    padding-right:0%;
    overflow: auto;
  }
  padding: 0px;
  background-color: #F1F1F1;
  position: relative;
  height: 100%;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/efficiency-resource/index.js